import React, { useState, useEffect } from 'react';
import './DetailMembre.css';
import { getEnfantsMembre } from '../services/api';

const API_BASE_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

const DetailMembre = ({ membre, onClose }) => {
  const [enfants, setEnfants] = useState([]);
  const [loadingEnfants, setLoadingEnfants] = useState(false);

  useEffect(() => {
    if (membre && membre.id) {
      loadEnfants();
    } else {
      setEnfants([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membre?.id]);

  const loadEnfants = async () => {
    if (!membre?.id) return;
    
    setLoadingEnfants(true);
    try {
      const response = await getEnfantsMembre(membre.id);
      const enfantsData = response?.data || response || [];
      setEnfants(Array.isArray(enfantsData) ? enfantsData : []);
    } catch (error) {
      console.error('Erreur lors du chargement des enfants:', error);
      setEnfants([]);
    } finally {
      setLoadingEnfants(false);
    }
  };

  if (!membre) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  return (
    <div className="detail-modal-overlay" onClick={onClose}>
      <div className="detail-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="detail-header">
          <h2>Détails du Membre</h2>
          <button className="detail-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="detail-body">
          {/* Photo et informations principales */}
          <div className="detail-main-section">
            <div className="detail-photo-section">
              {membre.photo ? (
                <img 
                  src={`${API_BASE_URL}${membre.photo}`} 
                  alt={`${membre.nom} ${membre.prenom}`}
                  className="detail-photo"
                />
              ) : (
                <div className="detail-photo-placeholder">Aucune photo</div>
              )}
            </div>

            <div className="detail-info-section">
              <div className="detail-info-group">
                <h3>Informations Personnelles</h3>
                <div className="detail-field">
                  <span className="detail-label">Numéro Matricule :</span>
                  <span className="detail-value detail-value-highlight">{membre.numero_matricule}</span>
                </div>
                <div className="detail-field">
                  <span className="detail-label">Nom :</span>
                  <span className="detail-value">{membre.nom}</span>
                </div>
                {membre.postnom && (
                  <div className="detail-field">
                    <span className="detail-label">Postnom :</span>
                    <span className="detail-value">{membre.postnom}</span>
                  </div>
                )}
                <div className="detail-field">
                  <span className="detail-label">Prénom :</span>
                  <span className="detail-value">{membre.prenom}</span>
                </div>
                <div className="detail-field">
                  <span className="detail-label">Date de naissance :</span>
                  <span className="detail-value">{formatDate(membre.date_naissance)}</span>
                </div>
                {membre.lieu_naissance && (
                  <div className="detail-field">
                    <span className="detail-label">Lieu de naissance :</span>
                    <span className="detail-value">{membre.lieu_naissance}</span>
                  </div>
                )}
                {membre.telephone && (
                  <div className="detail-field">
                    <span className="detail-label">Téléphone :</span>
                    <span className="detail-value">{membre.telephone}</span>
                  </div>
                )}
                {membre.profession && (
                  <div className="detail-field">
                    <span className="detail-label">Profession :</span>
                    <span className="detail-value">{membre.profession}</span>
                  </div>
                )}
                {membre.association && (
                  <div className="detail-field">
                    <span className="detail-label">Association :</span>
                    <span className="detail-value">{membre.association}</span>
                  </div>
                )}
              </div>

              <div className="detail-info-group">
                <h3>Adresse</h3>
                {membre.quartier && (
                  <div className="detail-field">
                    <span className="detail-label">Quartier :</span>
                    <span className="detail-value">{membre.quartier}</span>
                  </div>
                )}
                {membre.commune && (
                  <div className="detail-field">
                    <span className="detail-label">Commune :</span>
                    <span className="detail-value">{membre.commune}</span>
                  </div>
                )}
              </div>

              {membre.nom_epouse && (
                <div className="detail-info-group">
                  <h3>Famille</h3>
                  <div className="detail-field">
                    <span className="detail-label">Nom de l'épouse/époux :</span>
                    <span className="detail-value">{membre.nom_epouse}</span>
                  </div>
                </div>
              )}

              <div className="detail-info-group">
                <h3>Informations d'Adhésion</h3>
                <div className="detail-field">
                  <span className="detail-label">Date d'adhésion :</span>
                  <span className="detail-value">{formatDate(membre.date_adhesion)}</span>
                </div>
                {membre.nom_recolteur && (
                  <div className="detail-field">
                    <span className="detail-label">Récolteur :</span>
                    <span className="detail-value">{membre.nom_recolteur}</span>
                  </div>
                )}
                {membre.code_barres && (
                  <div className="detail-field">
                    <span className="detail-label">Code-barres :</span>
                    <span className="detail-value detail-code-barres">{membre.code_barres}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Liste des enfants */}
          <div className="detail-enfants-section">
            <h3>Enfants ({enfants.length})</h3>
            {loadingEnfants ? (
              <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                Chargement des enfants...
              </div>
            ) : enfants.length > 0 ? (
              <div className="detail-enfants-list" style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', fontSize: '14px' }}>Photo</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', fontSize: '14px' }}>Nom</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', fontSize: '14px' }}>Prénom</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', fontSize: '14px' }}>Date de naissance</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', fontSize: '14px' }}>Lien</th>
                    </tr>
                  </thead>
                  <tbody>
                    {enfants.map((enfant, index) => (
                      <tr 
                        key={enfant.id || index} 
                        style={{ 
                          borderBottom: '1px solid #dee2e6',
                          backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa'
                        }}
                      >
                        <td style={{ padding: '10px', fontSize: '14px' }}>
                          {enfant.photo ? (
                            <img 
                              src={`${API_BASE_URL}${enfant.photo}`} 
                              alt={`${enfant.nom} ${enfant.prenom}`}
                              style={{ 
                                width: '50px', 
                                height: '50px', 
                                objectFit: 'cover', 
                                borderRadius: '4px',
                                border: '1px solid #ddd'
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : (
                            <span style={{ color: '#999', fontSize: '12px' }}>Pas de photo</span>
                          )}
                        </td>
                        <td style={{ padding: '10px', fontSize: '14px' }}>{enfant.nom || '-'}</td>
                        <td style={{ padding: '10px', fontSize: '14px' }}>{enfant.prenom || '-'}</td>
                        <td style={{ padding: '10px', fontSize: '14px' }}>{formatDate(enfant.date_naissance)}</td>
                        <td style={{ padding: '10px', fontSize: '14px' }}>{enfant.lien || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ padding: '20px', textAlign: 'center', color: '#999', fontStyle: 'italic' }}>
                Aucun enfant enregistré
              </div>
            )}
          </div>

          {/* Signature */}
          {membre.photo_signature && (
            <div className="detail-signature-section">
              <h3>Signature</h3>
              <img 
                src={`${API_BASE_URL}${membre.photo_signature}`} 
                alt="Signature"
                className="detail-signature"
              />
            </div>
          )}

          {/* Identifiants de Connexion - À la fin */}
          <div className="detail-info-group detail-credentials" style={{ marginTop: '20px' }}>
            <h3>Identifiants de Connexion</h3>
            <div className="detail-field">
              <span className="detail-label">Numéro matricule :</span>
              <span className="detail-value detail-value-highlight">{membre.numero_matricule}</span>
            </div>
            <div className="detail-field">
              <span className="detail-label">Mot de passe :</span>
              <span className="detail-value detail-password">{membre.password || 'Non défini'}</span>
            </div>
            <div className="detail-field" style={{ marginTop: '10px', padding: '10px', background: '#f8f9fa', borderRadius: '5px', fontSize: '12px', color: '#666' }}>
              <strong>Note :</strong> Le membre peut se connecter avec son numéro matricule ({membre.numero_matricule}) et son mot de passe.
            </div>
          </div>
        </div>

        <div className="detail-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailMembre;

